// source https://www.figma.com/file/EdnclI2dElnwKD06w0Vw3K/Food-UI-Kit?node-id=890%3A1239

export enum SolidColors {
  // REDS
  red900 = '#981B25',
  red700 = '#C91D2B',
  red500 = '#EB4755',
  red300 = '#F9868F',
  red200 = '#FFC2C9',
  red100 = '#FEE7E9',
  // YELLOWS
  yellow900 = '#FF8800',
  yellow700 = '#FFB200',
  yellow500 = '#FFD400',
  yellow300 = '#FFE566',
  yellow200 = '#FFF0A8',
  yellow100 = '#FFF8D6',
  // GREENS
  green900 = '#127042',
  green700 = '#1D965C',
  green500 = '#32BB78',
  green300 = '#5AE1A0',
  green200 = '#A1F7CD',
  green100 = '#E0FFF0',
  green50 = '#E8F5E9',
  // PURPLES
  purple900 = '#313887',
  purple700 = '#4450D5',
  purple500 = '#5B68F6',
  purple300 = '#848FFF',
  purple200 = '#B8BEFF',
  purple100 = '#EBECFF',
  // NEUTRAL
  black = '#000000',
  neutral900 = '#2F313F',
  neutral800 = '#585A68',
  neutral700 = '#818391',
  neutral600 = '#A9ABB9',
  neutral500 = '#BFC0CB',
  neutral400 = '#D3D4DC',
  neutral300 = '#E9EAEE',
  neutral200 = '#F4F4F6',
  neutral100 = '#F9FAFB',
  white = '#FFFFFF',
}

export enum TransparentColors {
  disabledGreen = 'rgba(52, 209, 134, 0.38)',
  disabledRed = 'rgba(255, 82, 102, 0.38)',
  overlayGray = 'rgba(0, 0, 0, 0.5)',
  overlayWhite = 'rgba(255, 255, 255, 0.8)',
  transparent = 'transparent',
  transparent900 = 'rgba(0, 0, 0, 0.84)',
}

export const Colors = { ...SolidColors, ...TransparentColors };
